import { CdnService } from '@/common/services/cdn/cdn.service';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'cdn',
})
export class CdnPipe implements PipeTransform {
    transform(resource: string): string {
        return CdnService.url(resource);
    }
}
